// shared config file
if (process.env.NODE_ENV == 'development') {
  var dataAPIURL = 'http://localhost:5001'
  var esignAPIURL = 'http://localhost:5001'
  var captureAPIURL = 'http://localhost:5002'
  var recaptchaKey = "6Lejwb0jAAAAAKaw8C_NN33CS3eC8Sb9Zw5MdQLh"
} else {
  var dataAPIURL = 'https://data-api.expertevidence.org'
  var esignAPIURL = 'https://esign.expertevidence.org'
  var captureAPIURL = 'https://capture-api.expertevidence.org'
  var recaptchaKey = '6LchtL0jAAAAAIM2xETh0cP3WFY2Vx7Z_bRYSxpu'
}
export default { dataAPIURL, esignAPIURL, captureAPIURL, recaptchaKey }



// WEBPACK FOOTER //
// ./src/config.js